export { Necesitas } from './Necesitas';
export { Cuesta } from './Cuesta';
export { Hablar } from './Hablar';
export { Ser } from './Ser';
export { QueEs } from './QueEs';
